import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import { ResponsiveChord } from "@nivo/chord";
//import { ResponsiveSankey } from "@nivo/sankey";
import {API, BROKERID} from "../../../config";
import _ from 'lodash';

import OrderList from './components/OrderList';
import Paper from '@material-ui/core/Paper';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import DataTile from "../company/components/DataTile";

const OpenBuyOrders = API.service('buy-order');
const OpenSellOrders = API.service('sell-order');
const CompletedTrades = API.service('completed-trades');
const Withdrawals = API.service('withdrawal');
const inbound = API.service('inbound-transfers');

const moment = require('moment');

const styles = theme => ({
  layoutRoot: {
    backgroundColor: '#23272f',
    display: 'flex',
    flex: 1,
    height: '100vh',
    overflow: 'hidden'
  },
  container: {
    flex: '1 0 auto',
  },
  tabRoot: {
    minWidth: 100,
  },
  tabcontent: {
    borderTop: "1px solid #1890ff"
  },
  row: {
    height: "auto",

    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default
    }
  },
  cell: {
    padding: '4px 8px 4px 8px',
    cursor: 'pointer'
  },
  margin: {
    margin: theme.spacing.unit,
  },
  textField: {
    flex: 'none',
    width: 'calc(100% - 20px)',
  },
  flexBox: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#23272f',

    '&.center': {
      alignItems: 'center',
    }
  },
  margin20: {
    margin: 20,
  },
  marginX5: {
    marginTop: 5,
    marginBottom: 5,
  },
  tableHeader: {
    height: 35,

    '@media (max-width: 1680px)': {
      height: 25,
    },
  },
  tableRow: {
    background: '#2e323a',
    marginTop: 3,
    height: 25,

    '@media (max-width: 1680px)': {
      height: 25,
    },
  },
  whiteScrollHandler: {
    overflowY: 'auto',
  }
})

class Dashboard extends Component {
  state = {
    periodFrom: '2000-01-01',
    periodTo: '2020-12-31',
    valueFrom: '',
    valueTo: '',
    selectedTab: 0,
    selectedOrderTab: 0,
    openOrder: [],
    completedOrder: [],
    cList: [],
    nodes: [],
    links: false,
    chordKeys: [],
    Matrix: [],
    sortIndex: 0, // Sort index of first tab's table
    sortOrder: -1, // Sort order of first tab's table
    sortIndex_1: 0, // Sort index of second tab's table
    sortOrder_1: -1, //Sort order of second tab's table
    query: '',
    withdrawal_count:0,
    inbound_count:0,
  }

  updateData = () => {
    const app = this;

    inbound.find({"query":{"_status":{"$lt":64},"_timestamp":{"$gte":moment().subtract(7, 'days').format("Y-MM-DD HH:mm:ss")}}}).then(inv =>{
      app.setState({
        inbound_count:inv.total
      })
    }).catch(e=>{
      console.log('Error Loading:', e);
      app.setState({
        error:'Error: ' + e
      })
    })

    Withdrawals.find({query:{_status:0}}).then(w=>{
      app.setState({
        withdrawal_count: w.total
      })
    }).catch(e=>{
      console.log('Error Loading:', e);
      app.setState({
        error:'Error: ' + e
      })
    });

    //2

    OpenBuyOrders.find({ query: { incl: ['broker', 'company'], _broker_id: BROKERID, $sort: { _ts_order_posted: -1 }, _status: 0, $limit: 50 } }).then(bo => {
      OpenSellOrders.find({ query: { $sort: { _ts_order_posted: -1 }, _broker_id: BROKERID, _status: 0, incl: ['broker', 'company'], $limit: 50 } }).then(so => {
        order = [...bo.data, ...so.data];
        order = _.orderBy(order, ['_ts_order_posted'], ['asc']);

        app.setState({
          openOrder: order,
        });
      });
    });

    var investors = [];
    var nodes = [];
    var links = [];
    var order = [];
    var complete = [];
    CompletedTrades.find({ query: { $sort: { _ts_executed: 1 }, $or: {_selling_broker_id: BROKERID, _buying_broker_id: BROKERID}, $limit: 20, incl: ['brokers'] } }).then(ct => {
      complete = _.merge(ct.data, complete);
      complete = _.orderBy(complete, ['_ts_executed'], ['desc']);

      var chordKeys = [];
      var matrix = [];
      ct.data.forEach((c, k) => {
        if (chordKeys.indexOf(c._selling_investor_account) === -1) {
          chordKeys.push(c._selling_investor_account)
        }

        if (chordKeys.indexOf(c._buying_investor_account) === -1) {
          chordKeys.push(c._buying_investor_account)
        }
      });
      chordKeys.forEach((v, k) => {
        matrix[k] = [];
        chordKeys.forEach((v1, k1) => {
          matrix[k][k1] = 0;
        })
      })

      ct.data.forEach((c, k) => {
        if (typeof matrix[chordKeys.indexOf(c._selling_investor_account)] !== 'undefined' && typeof matrix[chordKeys.indexOf(c._selling_investor_account)][chordKeys.indexOf(c._buying_investor_account)] !== 'undefined') {
          matrix[chordKeys.indexOf(c._selling_investor_account)][chordKeys.indexOf(c._buying_investor_account)] += c._quantity;
        } else {
          if (typeof matrix[chordKeys.indexOf(c._selling_investor_account)] === 'undefined') {
            matrix[chordKeys.indexOf(c._selling_investor_account)] = [];
          }
          matrix[chordKeys.indexOf(c._selling_investor_account)][chordKeys.indexOf(c._buying_investor_account)] = c._quantity;
        }
      });

      ct.data.forEach((c, k) => {
        if (investors.indexOf("S" + c._selling_investor_account) === -1) {
          investors.push("S" + c._selling_investor_account);
          nodes.push({ "id": "S" + c._selling_investor_account.toString(), "color": "hsl(178, 70%, 50%)" })
        }

        if (investors.indexOf("B" + c._buying_investor_account) === -1) {
          investors.push("B" + c._buying_investor_account);
          nodes.push({ "id": "B" + c._buying_investor_account.toString(), "color": "hsl(178, 70%, 50%)" })
        }

        links.push({
          "source": "S" + c._selling_investor_account.toString(),
          "target": "B" + c._buying_investor_account.toString(),
          "value": c._quantity
        })
      });

      var data = { links: links, nodes: nodes };
      app.setState({
        nodes: data,
        links: true,
        chordKeys,
        matrix
      }, () => {
        console.log(this.state.nodes)
      });

      app.setState({
        completedOrder: complete,
      });
    }
    )
  }

  componentDidMount() {
    const app = this;
    window.addEventListener("resize", () => {
      this.setState({ windowHeight: window.innerHeight - 122 })
    });

    app.updateData();

    app.time = setInterval(function () {
      app.updateData()
    }, 5000)
  }

  componentWillUnmount() {
    const app = this;
    window.clearInterval(app.time)
  }

  handleTabChangeSecondary = (event, selectedOrderTab) => {
    this.setState({ selectedOrderTab, query: '' }, () => this._filterOrder());
  };

  handleSort = (id) => ev => {
    const { sortOrder, selectedOrderTab, sortOrder_1 } = this.state;
    
    if (!selectedOrderTab) {
      this.setState({ sortIndex: id, sortOrder: -sortOrder });
    } else {
      this.setState({ sortIndex_1: id, sortOrder_1: -sortOrder_1 });
    }
  };

  handleChange = (name) => ev => {
    this.setState({[name]: ev.target.value});
  };

  _filterOrder = () => {
    const { selectedOrderTab, openOrder, completedOrder } = this.state;

    if (!selectedOrderTab) {
      this.setState({
        openOrder: openOrder.filter(order => this._checkIfResult([
          order.Authorized_Brokers[0]._name,
          order.Companies[0]._company_symbol,
          (typeof order['_sell_order_confirmation'] === 'undefined') ? 'buy' : 'sell',
          order._type,
        ])),
      });
    } else {
      this.setState({
        completedOrder: completedOrder.filter(order => this._checkIfResult([
          order._selling_investor_account,
          order.Selling_Broker[0]._name,
          order._buying_investor_account,
          order.Buying_Broker[0]._name,
        ])),
      });
    }
  };

  handleQueryChange = (ev) => {
    this.setState({ query: ev.target.value.toLowerCase() }, () => this._filterOrder());
  };

  _checkIfResult = (arr) => {
    const { query } = this.state;

    for (let i of arr) {
      if (i.toLowerCase().includes(query)) {
        return true;
      }
    }

    return false;
  }

  render() {

    const { classes } = this.props

    return (
          <div className="flex flex-row flex-wrap px-8 mt-4">
            <div className="px-4 py-2 m-2 w-1/2 my-8 text-center">
              <Paper className="" style={{ height: '465px' }} elevation={0}>
                <AppBar position="static" elevation={4} color={"default"} style={{boxShadow:'none'}}>
                  <Toolbar>
                    <Typography variant="title" color="inherit" className={classes.flex}>
                      Statistics
                    </Typography>
                  </Toolbar>
                </AppBar>
                <div className={"flex"}>
                  <DataTile
                    data={{
                      conversion: {
                        value   : this.state.openOrder.length,
                      },
                      datasets  : [],
                      ...this.state.widget_options}}
                    title="Open Orders" showChart={false} klass={"flex-1 pb-24 text-center"}/>
                    <DataTile
                    data={{
                      conversion: {
                        value   : this.state.withdrawal_count,
                      },
                      datasets  : [],
                      ...this.state.widget_options}}
                    title="Pending Withdrawals" showChart={false} klass={"flex-1 pb-24 text-center"}/>
                </div>
                <div className={"flex"}>
                    <DataTile
                    data={{
                      conversion: {
                        value   : this.state.inbound_count,
                      },
                      datasets  : [],
                      ...this.state.widget_options}}
                    title="Pending Deposits" showChart={false} klass={"flex-1 pb-24 text-center"}/>
                </div>
              </Paper>
            </div>

            <div className="px-4 py-2 m-2 w-1/2 my-8 text-center">
              <Paper>
                <AppBar position="static" elevation={0} color={"default"} style={{boxShadow:'none'}}>
                  <Toolbar>
                    <Typography variant="title" color="inherit" className={classes.flex}>
                      Recently Executed
                    </Typography>
                  </Toolbar>
                </AppBar>
                <div className="p-12 text-black text-center h-64" style={{ height: '400px' }}>
                  {(this.state.links) &&
                  <ResponsiveChord
                      matrix={this.state.matrix}
                      keys={this.state.chordKeys}
                      margin={{
                        "top": 50,
                        "right": 60,
                        "bottom": 50,
                        "left": 60
                      }}
                      padAngle={0.02}
                      innerRadiusRatio={0.96}
                      innerRadiusOffset={0.02}
                      arcOpacity={1}
                      arcBorderWidth={0}
                      arcBorderColor="inherit:darker(0.4)"
                      ribbonOpacity={0.5}
                      ribbonBorderWidth={0}
                      ribbonBorderColor="inherit:darker(0.4)"
                      enableLabel={true}
                      label="id"
                      labelOffset={12}
                      labelRotation={-90}
                      labelTextColor="inherit:darker(1)"
                      colors="category10"
                      isInteractive={true}
                      arcHoverOpacity={1}
                      arcHoverOthersOpacity={0.25}
                      ribbonHoverOpacity={0.75}
                      ribbonHoverOthersOpacity={0.25}
                      animate={true}
                      motionStiffness={90}
                      motionDamping={7}
                  />
                  }
                </div>
              </Paper>
            </div>
            <OrderList />
          </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(withRouter(Dashboard));
